import { ReactComponent as ArrowDownToBracketSvg } from '../../fonts/arrow-down-to-bracket-regular-full.svg';

type Props = React.SVGProps<SVGSVGElement>;

export default function ArrowDownToBracketIcon(props: Props) {
    return <ArrowDownToBracketSvg {...props} />;
}
